// src/api/slice.js
import { resolveBase } from "./config";

export async function sliceHealth() {
  const base = resolveBase("slice");
  if (!base) throw new Error("Slice API not configured");
  const r = await fetch(`${base}/health`, { credentials: "omit" });
  if (!r.ok) throw new Error("slice health");
  return r.json();
}

export async function runSample() {
  const base = resolveBase("slice");
  if (!base) throw new Error("Slice API not configured");
  
  // Temporary fallback: if slice chat fails, use lock chat endpoint
  const lockBase = resolveBase("lock");
  
  const body = {
    cases: [
      {
        id: "drift-haiku",
        query: "Write a one-line haiku about drift checks.",
        docs: [
          {
            id: "about.md",
            title: "LoafLock",
            text: "LoafLock freezes prompts and catches drift via a lockfile. Drift changes outputs over time.",
          },
        ],
        budget: 600,
        assert: [{ type: "contains", value: "drift" }],
      },
      {
        id: "explain-lock", 
        query: "In one sentence, what problem does a lockfile solve in LLM apps?",
        docs: [
          {
            id: "readme.md",
            text: "A lockfile pins known-good outputs so regressions are visible in PRs.",
          },
        ],
        budget: 400,
        assert: [{ type: "contains", value: "lockfile" }],
      },
      {
        id: "simple-test",
        query: "What is 2+2?",
        docs: [],
        budget: 200,
        assert: [{ type: "contains", value: "4" }],
      },
    ],
    // Override chat service to use working lock API until slice chat is fixed
    chat_override: lockBase
  };
  
  const r = await fetch(`${base}/slice/run`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "omit"
  });
  if (!r.ok) {
    const errorText = await r.text().catch(() => "");
    throw new Error(`Slice run ${r.status}${errorText ? `: ${errorText}` : ""}`);
  }
  return r.json();
}
